import { host_haijipet_func } from '@/api/host'

const haijiApi = {
    outSecurityCodeUrl: `${host_haijipet_func()}/public/outer/security_codes`, // 三方客户防伪码查询接口
}

export {
    haijiApi
}